import { render } from "./a-partners-section.vue?vue&type=template&id=dd73d7fc&scoped=true"
import script from "./a-partners-section.vue?vue&type=script&lang=js"
export * from "./a-partners-section.vue?vue&type=script&lang=js"

import "./a-partners-section.vue?vue&type=style&index=0&id=dd73d7fc&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/academy/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd73d7fc"]])

export default __exports__